import Image from '@app/components/Image'
import ImageLightbox from '@app/components/ImageLightbox'
import { IAttachment } from '@app/models/Attachment'
import { AttachmentType, ImageSize } from '@app/models/enums'
import classNames from 'classnames'
import { List } from 'immutable'
import * as React from 'react'
import './PhotoStrip.scss'

export interface IPhotoStripProps {
  className?: string
  photos: List<IAttachment>
  propertyId?: string
  style?: React.CSSProperties
}

export class PhotoStrip extends React.PureComponent<IPhotoStripProps> {
  private lightboxRef: React.RefObject<ImageLightbox>

  constructor(props: IPhotoStripProps) {
    super(props)

    this.lightboxRef = React.createRef<ImageLightbox>()
  }
  public render() {
    if (this.props.photos.size === 0) {
      return null
    }

    const photos = this.props.photos.map((p, i) => {
      if (p === undefined || i === undefined) {
        return null
      }

      if (
        p.type !== AttachmentType.Photo &&
        p.type !== AttachmentType.MainPhoto
      ) {
        return null
      }

      return (
        <Image
          key={p.id}
          defaultImageUrl='/images/default-image_h_100_w_100.png'
          height={75}
          image={p}
          onClick={() => this._showLightbox(i)}
          size={ImageSize.h100w100}
          width={75}
        />
      )
    })

    return (
      <div
        className={classNames('photo-strip', this.props.className)}
        style={this.props.style}
      >
        {photos}
        <ImageLightbox
          images={this.props.photos}
          propertyId={this.props.propertyId}
          ref={this.lightboxRef}
        />
      </div>
    )
  }

  private _showLightbox(selectedIndex: number) {
    if (this.lightboxRef.current) {
      this.lightboxRef.current.show(selectedIndex)
    }
  }
}
